export const numberedNavButtonNotificationStyle = {
  top: -8,
  right: -16,
};

export const dotNavButtonNotificationStyle = {
  top: -4,
  right: -6,
};
